import { useQuery } from '@tanstack/react-query';

import { DispensariesApi } from 'api';
import { DISPENSARY_KEY } from 'tanstack-hooks/keys';

export function useDispensary(dispensaryId: string) {
  const dispensariesApi = new DispensariesApi();

  const { data: dispensary, isLoading: isLoadingDispensary } = useQuery({
    enabled: !!dispensaryId.length,
    queryKey: [DISPENSARY_KEY, dispensaryId],
    queryFn: () => dispensariesApi.getDispensary(dispensaryId),
    meta: {
      snackbarErrorMessage: 'There was an issue loading the CRB. Please try again.'
    }
  });

  return { dispensary, isLoadingDispensary };
}
